// Styles for Dashboard elements

export const dashStyles = {
    avatar: {backgroundColor: '#f1603d', width: 40, height: 40},
    break: {display: 'block', width: '100%', height: 0, border: 'none', margin: 0},
    dashIcon: {float: 'right', width: 68, height: 68, padding: 16, color: '#f1603d'},
    detail: {fontSize: '12px', color: '#1478b9'},
    diagram: {display: 'block', width: 'auto', maxWidth: '100%', height: 'auto', margin: 0},
    diagramLeft: {
        display: 'inline-block',
        float: 'left',
        width: 'auto',
        maxWidth: '200px',
        height: 'auto',
        margin: '0 1em 1em 0.5em'
    },
    diagramSmall: {
        display: 'inline-block',
        float: 'right',
        width: '200px',
        maxWidth: '100%',
        height: 'auto',
        margin: '0 0 1em 1em'
    },
    fieldLink: {color: '#1478b9', textDecoration: 'none', borderBottom: '1px dotted rgba(33,33,33,0.5)'},
    flexRow: {display: 'flex', msFlexDirection: 'row', flexDirection: 'row'},
    listCard: {borderLeft: 'solid 4px #262360', flex: 1},
    listCardHalf: {
        flex: '0 1 50%',
        display: 'inline-block',
        width: 'calc(50% - 1em)',
        margin: '0 1em 0 0',
        verticalAlign: 'top'
    },
    listCardLast: {margin: '0'},
    marginBottom: {marginBottom: '2em'}
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-dashboard.js